import React, {Component} from 'react';

import { Navbar, Nav } from 'react-bootstrap';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from 'react-router-dom';

import background from './background-unsplashed-3.jpg';
import headshot from './headshot.jpg';
import remirus from './remirus.jpg';
import './App.css';

class App extends Component {
  constructor() {
    super();
    this.state = {
      searchButtonAnimation: false
    }
  }

  buttonHover = () => {
    this.setState({searchButtonAnimation: true});
  }

  buttonHoverExit = () => {
    this.setState({searchButtonAnimation: false});
  }

  render() {
    return (
      <Router>
        <div className="App">
          <Navbar className="Navbar" fixed="top" bg="light" expand="md">
            <Navbar.Brand className="Remirus-logo" href="http://www.remirus.com" target="_blank">
              <img
                src={remirus}
                height="90px"
                alt="Remirus Real Estate Brokerage" />
            </Navbar.Brand>
            <Navbar.Collapse>
              <Navbar.Text>
                41000 Woodward Ave., Suite 350 East<br />
                Bloomfield Hills, MI 48304
              </Navbar.Text>
            </Navbar.Collapse>
            <Navbar.Collapse className="justify-content-end">
              <Nav.Link href="/">Home</Nav.Link>
              <Nav.Link href="/search">Search Listings</Nav.Link>
            </Navbar.Collapse>
            <Navbar.Toggle />
          </Navbar>

          <Switch>
            <Route path="/search">
              <header className="App-header">
                <span style={{height: "10%"}} />
                <h3 id="search">Search Listings</h3>
                <div className="Search-frame">
                  <iframe title="Search Listings" src="https://matrix.realcomponline.com/Matrix/public/IDX.aspx?idx=f5b8e52" width="100%" height="100%" frameborder="0" marginwidth="0" marginheight="0"></iframe>
                </div>
              </header>
            </Route>
            <Route path="/">
              <header className="App-header">
                <img src={background} className="Splash-background" alt="Beautiful home" />
                <div className="Center-modal">
                  <div className="Center-modal-info">
                    <h2>Mirela Uselmann</h2>
                    <p>Michigan Realtor</p>
                    <a href="mailto:mirelauselmann@gmail.com" target="_blank" rel="noopener noreferrer" className="Email-link">mirelauselmann@gmail.com</a>
                    <p className="Basic-text">(313)-779-0333</p>
                  </div>
                  <div className="Center-modal-headshot">
                    <img src={headshot} className="Headshot" alt="Mirela Uselmann" />
                  </div>
                </div>
              </header>
            </Route>
          </Switch>
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js